import { animate, motion } from "framer-motion";
import { useEffect, useState } from "react";

interface CircularLoadingDotsProps {
  nDots: number;
  className?: string;
}

const CircularLoadingDots: React.FC<CircularLoadingDotsProps> = ({nDots, className = "relative w-[50px] h-[50px]"}) => {
  // State definition
  const [radius, setRadius] = useState(20);

  // Dots definition
  const dots = Array.from({ length: nDots });

  useEffect(() => {
    const controls = animate(10, 70, {
      repeat: Infinity,
      repeatType: "reverse",
      duration: 3,
      ease: "easeInOut",
      onUpdate: (latest) => setRadius(latest)
    });

    return () => controls.stop();
  }, []);

  return (
    <motion.div
      className={className}
      animate={{ rotate: 360 }}
      transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
    >
      {dots.map((_, index: number) => {
        const angle = (360 / dots.length) * index;
        const opacity = 0.25 + 0.75 * (index / dots.length);

        return (
          <motion.div
            key={`dot-${index}`}
            className="absolute w-2 h-2 rounded-full bg-secondary-500"
            style={{
              top: "50%",
              left: "50%",
              x: `${radius * Math.cos((angle * Math.PI) / 180)}px`,
              y: `${radius * Math.sin((angle * Math.PI) / 180)}px`,
              opacity,
              translateX: "-50%",
              translateY: "-50%",
            }}
          />
        );
      })}
    </motion.div>
  );
};

export default CircularLoadingDots;